export default {
  Login: {
    /* 登录 */
    login: "login",
    /* 登出 */
    loginOut: "logout",
    captcha: "login/captcha",
    sendMqtt: "h5Interface/sendMqtt"
  },
  Index: {
    main: "index/main"
  },

  AuthorityUser: {
    /* 添加用户 */
    addUser: "user/insert3",
    /* 修改用户 */
    editUser: "user/update3",
    /* 获取用户信息 */
    pageList: "user/page",
    /* {{$t('common.reset')}}密码${id} */
    resetPassword: "user/reset",
    /* 启用禁用账号${id}/${enable} */
    enabled: "user/enabled",
    delete: "user/delete",
    export: "user/export",
    importUser: "user/importUser",
    getVerifyCode: "user/getVerifyCode"
  },
  // IconList: {
  //   /* 加载图标 */
  //   loadIcon: "system/listIcon"
  // },
  User: {
    page: "user/page",
    insert: "user/insert",
    update: "user/update",
    updatePassword: "user/updatePassword",
    checkPassword: "user/checkPassword",
    resetPassword: "user/rechargePassword",
    getConfigByUserId: "paypalSetting/getByUserId",
    getCashuConfigByUserId: "cashuConfig/getByUserId",
    getPaymentWallConfigByUserId: "paymentWall/config/getByUserId",
    updatePaymentWallConfig: "paymentWall/config/update",
    insertPaymentWallConfig: "paymentWall/config/insert",
    getGccPayConfigByUserId: "gccPay/config/getByUserId",
    updateGccPayConfig: "gccPay/config/update",
    insertGccPayConfig: "gccPay/config/insert",
    addPaypal: "paypalSetting/insert",
    addCanshu: "cashuConfig/insert",
    editPaypal: "paypalSetting/update",
    editCanshu: "cashuConfig/update",
    uploadAvatar: "user/uploadAvatar",
    findPassword: "user/forgotPwd/update",
    validPass: "user/validPass",
    listUserByUsername: "user/list",
    deductAmount: "user/deductAmount",
    verifyUser: "user/forgotPwd/sendCode", // 验证手机号是否绑定用户账号
    listUserByParent: "user/listUserByParent",
    getUserById: "user/getUserById",
    listFinance: "user/listFinance3",
    loginJump: "user/accountRedirection",
    getByList: "role/list",
    domianmodify: "user/update/loginLocale",
    export: "user/export"
  },
  AuthorityMenu: {
    /* 加载地址url */
    list: "menu/list",
    insert: "menu/insert",
    update: "menu/update",
    delete: "menu/delete",
    listByPid: "menu/listByPid",
    updateInMenu: "menu/updateInMenu",
    listMenuName: "menu/listMenuName"
  },
  // AuthorityMenuUrl: {
  //   load: "menuUrl/load",
  //   loadUrl: "menuUrl/loadUrl",
  //   update: "menuUrl/update"
  // },
  AuthorityRole: {
    load: "role/page",
    loadRole: "role/list",
    save: "role/insert",
    update: "role/update",
    listByRole: "role/page",
    delete: "role/delete",
    listByPid: "role/list",
    updateInList: "role/updateInList",
    listRoleByUserType: "role/listRoleByUserType3"
  },
  AuthorityRoleMenu: {
    load: "menu/list",
    listMenu: "menu/getMenIdsByRoleId",
    update: "roleMenu/update",
    save: "role/configMenu",
    listAuth: "roleMenu/listAuth"
  },
  AuthorityUserRole: {
    load: "userRole/list",
    update: "userRole/update",
    save: "user/configRole",
    pageUserByRoleId: "user/page",
    listRoleByUserId: "role/list",
    clearRole: "user/clearRole"
  },
  // AuthorityCommonUrl: {
  //   load: "commonUrl/list",
  //   update: "commonUrl/update",
  //   loadOpen: "commonUrl/listOpen"
  // },
  // Message: {
  //   load: "message/load"
  // },
  // Notice: {
  //   getUser: "socket/getUser",
  //   kickOut: "socket/kickOut",
  //   sendUser: "socket/sendUser",
  //   banned: "socket/banned"
  // },
  LoginInfo: {
    page: "loginRecord/page",
    delete: "loginRecord/delete",
    clear: "loginInfo/clear"
  },
  OperationLog: {
    page: "systemActivityLog/page",
    delete: "systemActivityLog/delete"
  },
  // File: {
  //   upload: "file/upload"
  // },
  DictType: {
    loadDictType: "codes/page",
    list: "codes/list",
    save: "codes/insert",
    update: "codes/update",
    delete: "codes/delete"
  },
  DictData: {
    page: "codesValue/page",
    save: "codesValue/insert",
    update: "codesValue/update",
    delete: "codesValue/delete",
    listDictData: "codesValue/list",
    listLabel: "codesValue/getLabelById"
  },
  Machine: {
    page: "equipment/page",
    getMachineNo: "equipment/getMachineNo",
    insert: "equipment/insert",
    update: "equipment/update",
    delete: "equipment/delete",
    recover: "equipment/recover",
    userRecover: "userEquipment/recover",
    import: "equipment/import",
    export: "equipment/export",
    template: "equipment/template",
    machineList: "equipment/list",
    select: "userEquipment/select"
  },
  MachineGroup: {
    page: "equipmentTeam/page",
    update: "equipmentTeam/update",
    insert: "equipmentTeam/insert",
    list: "equipmentTeam/list",
    moveGroup: "equipmentTeam/giveEquipment",
    delete: "equipmentTeam/delete"
  },
  MachineType: {
    page: "equipmentType/page",
    update: "equipmentType/update",
    insert: "equipmentType/insert",
    list: "equipmentType/list"
  },
  MachineRecord: {
    page: "equipmentTakeRecord/page",
    online: "mqtt/record/page"
  },
  OffLineRecord: {
    page: "mqttRecord/page"
  },
  UserMachine: {
    saveError: "aisleGoods/exceptionHandling",
    unBindMac: "userEquipment/splitScreen/unbind",
    page: "userEquipment/page",
    upPage: "userEquipment/apk/page",
    goodsList: "goods/list",
    errorLook: "aisleGoods/page",
    update: "userEquipment/update",
    updatePos: "userEquipment/positioning",
    updatePreAuthAmount: "openDoor/operateApp/userEquipmentOpenDoor/updatePreAuthAmount",
    list: "equipment/list",
    userList: "userEquipment/list",
    listUser: "user/list",
    updateGroupId: "userEquipmentTeam/addOrRemoveEquipment",
    updateLabelId: "userEquipmentLabelTeam/addOrRemoveEquipment",
    listProduct: "aisleGoods/page",
    listUserMachineByGroupId: "userEquipment/list",
    listUserMachineSelect: "userEquipment/select",
    export: "userEquipment/export",
    deposit: "userEquipment/deposit",
    returnDeposit: "userEquipment/returnDeposit",
    payment: "userEquipment/payConfig",
    config: "userEquipment/batchAisleGoods",
    control: "userEquipment/remote",
    getcontrol: "userEquipment/remoteState",
    closeNetWork: "userEquipment/closeNetWork",
    openNetWork: "userEquipment/openNetWork",
    gmodify: "userEquipmentTeam/config",
    modify: "userEquipment/config",
    merge: "machine/line/product/merge",
    lastDeliveredTransactions: "userEquipment/lastDeliveredTransactions",
    relieve: "machine/line/product/merge/relieve",
    getQrCode: "userEquipment/getQrCode",
    sendMqtt: "userEquipment/sendLog",
    androidlog: "apkLog/page",
    userEquipment: "userMoveGroup/userEquipment",
    payRecord: "userEquipment/statRecord",
    payRecordClear: "userEquipment/statRecord/clear",
    getProduct: "product/getByPage",
    getCargoway: "machine/line/product/getByPage",
    ProductModeList: "machine/line/product/getByProductModeList",
    DeleteProductMode: "machine/line/product/deleteProductMode",
    SaveProductMode: "machine/line/product/saveProductMode",
    getCode: "userEquipment/electricLockSendCode",
    validCode: "userEquipment/electricLockValidCode",
    electricLockDirect: "userEquipment/electricLockDirect",
    saveRenvel: "userEquipment/commission/save",
    reStartBoard: "userEquipment/restart"
  },
  Map: {
    data: "map/userEquipment"
  },
  Notes: {
    test: "notes/test",
    add: "notes/add",
    getByMachineId: "notes/getByMachineId",
    getByMachineNo: "notes/getByMachineNo",
    update: "notes/update",
    updateByMachineNo: "notes/updateByMachineNo",
    updateAddressByEquipmentNo: "notes/updateAddressByEquipmentNo"
  },
  UserMachineGroup: {
    page: "userEquipmentTeam/page",
    choosePage: "userEquipment/select",
    list: "userEquipmentTeam/list",
    insert: "userEquipmentTeam/insert",
    update: "userEquipmentTeam/update",
    moveUserMachine: "userEquipmentTeam/giveEquipment",
    userMoveGroup: "userMoveGroup/page",
    userMoveGroupInsert: "userMoveGroup/insert",
    userMoveGroupUpdate: "userMoveGroup/update",
    delete: "userEquipmentTeam/delete"
  },
  UserMachineLabels: {
    page: "userEquipmentLabelTeam/page",
    list: "userEquipmentLabelTeam/list",
    choosePage: "userEquipment/select",
    insert: "userEquipmentLabelTeam/insert",
    update: "userEquipmentTeam/update",
    moveUserMachine: "equipmentTeam/moveGroup",
    userMoveGroup: "userMoveGroup/page",
    userMoveGroupInsert: "userMoveGroup/insert",
    userMoveGroupUpdate: "userMoveGroup/update",
    delete: "userEquipmentLabelTeam/delete"
  },
  ShippingOrder: {
    page: "shippingOrder/page",
    list: "shippingOrder/list",
    insert: "shippingOrder/insert",
    update: "shippingOrder/update",
    delete: "shippingOrder/delete",
    getEquipmentTeamByOrderId: "shippingOrder/getEquipmentTeamByOrderId",
    getEquipmentByTeamId: "shippingOrder/getEquipmentByTeamId",
    getPrintInfoByEquipmentId: "shippingOrder/getPrintInfoByEquipmentId"
  },
  ProductType: {
    page: "goodsType/page",
    insert: "goodsType/insert",
    update: "goodsType/update",
    list: "goodsType/list",
    delete: "goodsType/delete",
    usageCount: "goodsType/usageCount"
  },
  ProductTag: {
    page: "goodsTag/page",
    insert: "goodsTag/insert",
    update: "goodsTag/update",
    list: "goodsTag/list",
    delete: "goodsTag/delete"
  },
  // ProductSpecify: {
  //   page: "product/spec/page",
  //   insert: "product/spec/insert",
  //   update: "product/spec/update",
  //   delete: "product/spec/delete"
  // },
  Product: {
    page: "goods/page",
    list: "product/list",
    insert: "goods/insert",
    update: "goods/update",
    delete: "goods/delete",
    listProductTag: "product/listProductTag",
    insertCoupons: "discount/insert",
    getCoupons: "discount/page",
    deleteCoupon: "discount/delete",
    getCouponsCode: "discountCode/page",
    exportCoupon: "discount/export",
    exportCouponMa: "discountCode/export",
    symbol: "paypal/currency/symbol/list",
    speclist: "product/spec/list",
    select: "goods/select"
  },
  ProductSimilar: {
    detail: "goods/similar/detail",
    save: "goods/similar/save"
  },
  MachineLineProduct: {
    update: "aisleGoods/update",
    subSpec: "product/subSpec/list",
    export: "aisleGoods/export"
  },
  OpenDoor: {
    getSkuList: "openDoor/goodsOpenDoorSku/getByPage",
    getAisleGoodsConfig: "openDoor/openDoorAisleGoods/getMapByList",
    saveOrEditAisleGoods: "openDoor/openDoorAisleGoods/saveOrEdit",
    getQrCodeConfig: "openDoor/userEquipment/getByUserEquipmentId",
    // 同样的开锁动作，跟 doorcabinet App 的 post_opendoor 一致，但去掉 operateApp 段——
    // 那一段走的是 App 自己的登录态（会报 "User info expired"），Web 后台会话认证不了。
    // 不要用 UserMachine.electricLockDirect —— 那是传统弹簧货道机电子锁接口，对开门柜没用
    unlock: "openDoor/userEquipment/openDoor",
    // 视觉识别图片
    getSkuImageList: "openDoor/goodsOpenDoorSkuImage/getByPage",
    saveOrEditSkuImage: "openDoor/goodsOpenDoorSkuImage/saveOrEdit",
    materialImageInsert: "openDoor/goodsOpenDoorSkuImage/material/insert",
    materialImageDelete: "openDoor/goodsOpenDoorSkuImage/material/delete",
    materialSubmitForReview: "openDoor/goodsOpenDoorSkuImage/material/submitForReview",
    // 订单视频资源
    getOrderVideoResources: "openDoor/ordersOpenDoorResource/getByList",
    // 审核异常订单
    approvalOrder: "openDoor/ordersOpenDoor/approvalOrder"
  },
  Adverts: {
    page: "ad/page",
    delete: "ad/delete",
    insert: "ad/insert",
    update: "ad/update",
    listAdvertByGroupId: "ad/list"
  },
  UserEquipmentAdvert: {
    detail: "userEquipmentAd/detail",
    add: "userEquipmentAd/add",
    remove: "userEquipmentAd/remove",
    batchSave: "userEquipmentAd/batchSave"
  },
  AppVersion: {
    page: "apkVersion/page",
    listAppVersion: "apkVersion/list",
    insert: "app/version/insert",
    update: "apkVersion/update"
  },
  // machineVersion: {
  //   page: "apkVersion/page",
  //   listMachineVersion: "app/version/listMachineVersion",
  //   insert: "app/version/insert",
  //   update: "apkVersion/update"
  // },
  Order: {
    page: "order/page",
    export: "order/export",
    refund: "order/refund",
    refundByOrderId: "order/refund"
  },
  // 保存的筛选视图：复用通用 systemConfig 存取（type=FILTER_VIEW）。
  // 注意：后端 SystemConfigEnum 目前还没有 FILTER_VIEW，服务端保存/读取会返回失败，
  // VtmFilterBar 对此已做静默降级（回退本地缓存）——后端补上该枚举值后即可跨设备同步。
  FilterView: {
    get: "systemConfig/get",
    save: "systemConfig/save"
  },
  RefundRecord: {
    page: "ordersRefund/page"
  },
  Upload: {
    product: "upload/goods",
    advert: "upload/ad",
    appIcon: "upload/img/Icon",
    app: "upload/apk",
    join: "upload/joinUser",
    renew: "upload/img/rent",
    wallet: "upload/wallet",
    setting: "upload/logo",
    sdfile: "upload/3d",
    feedback: "upload/feedback",
    theme: "upload/style",
    smokeCard: "smokeCard/upload",
    bouncer: "upload/bouncer",
    icewm: "upload/towel"
  },
  // Join: {
  //   page: "joinPay/page",
  //   insert: "joinPay/insert",
  //   update: "joinPay/update",
  //   picsInfo: "joinPay/picsInfo",
  //   querySignContent: "joinPay/querySignContent",
  //   joinSign: "joinPay/joinSign",
  //   queryJoinOrder: "joinPay/queryJoinOrder",
  //   queryJoinRefundOrder: "joinPay/queryJoinRefundOrder",
  //   queryBalance: "joinPay/queryBalance"
  // },
  // Deposit: {
  //   page: "depositRefund/page",
  //   insert: "depositRefund/insert"
  // },
  // CashBack: {
  //   page: "cashBack/page"
  // },
  // CashBackRecord: {
  //   page: "cashBackRecord/page",
  //   insert: "cashBackRecord/insert"
  // },
  // AgentProfit: {
  //   page: "agentProfit/page",
  //   cashPrice: "agentProfit/cashPrice"
  // },
  RenewalRecord: {
    page: "rentRecord/page",
    insert: "rentRecord/insert",
    getPayList: "userEquipment/getRentPrice",
    getPayConfig: "money/bankInfo",
    update: "rentRecord/update",
    renew: "rentRecord/confirm",
    revokeRenew: "rentRecord/cancel",
    renewalPAYPAL: "pay/PAYPAL/WEB",
    recordGetById: "rentRecord/getById",
    calculateCostRenewal: "rentRecord/calculateCostRenewal",
    export: "rentRecord/export"
  },
  RechargeRecord: {
    getPayConfig: "money/bankInfo",
    insert: "moneyOrder/insert",
    rechargePAYPAL: "pay/PAYPAL/WEB",
    update: "moneyOrder/update",
    recharge: "moneyOrder/page",
    confirm: "moneyOrder/confirm",
    revokeRecharge: "moneyOrder/cancel",
    getById: "moneyOrder/getById"
  },
  ICard: {
    page: "iCard/page",
    insert: "iCard/insert",
    update: "iCard/update",
    import: "iCard/import",
    template: "iCard/template",
    delete: "iCard/delete",
    reset: "iCard/reset"
  },
  IDard: {
    applyIDard: "cert/apply",
    insertIDard: "cert/insert",
    updateIDard: "cert/update",
    deleteIDard: "cert/delete",
    pageIDard: "cert/page",
    cert: "upload/cert",
    jzupload: "h5Interface/upload"
  },
  // FinanceGroup: {
  //   page: "finance/group/page",
  //   insert: "finance/group/insert",
  //   update: "finance/group/update",
  //   listFinance: "finance/group/listFinance",
  //   delete: "finance/group/delete"
  // },
  Statistics: {
    machine: "statistics/machine",
    product: "statistics/product",
    user: "stat/user/table",
    date: "statistics/date",
    exportMachine: "statistics/exportMachine",
    exportProduct: "statistics/exportProduct",
    exportUser: "stat/user/export",
    exportDate: "statistics/exportDate",
    advertRecord: "advertRecord/pay/page",
    advertRecordExport: "advertRecord/pay/export"
  },
  myWallet: {
    wallet: "money/get",
    recharge: "recharge/getById",
    walletlog: "MoneyLog/page",
    export: "MoneyLog/export",
    wInsert: "userWithdrawal/insert",
    page: "userWithdrawal/page",
    cancel: "userWithdrawal/cancel",
    confirm: "userWithdrawal/confirm",
    account: "moneyUse/page",
    moneyPage: "money/page",
    detail: "moneyUse/page",
    recordexport: "moneyUse/export"
  },
  Email: {
    save: "systemConfig/save"
  },
  Promote: {
    save: "systemConfig/save",
    get: "systemConfig/get",
    getDefault: "systemConfig/default",
    getDictValue: "codesValue/list"
  },
  Upgrade: {
    listAppVersion: "app/version/listAppVersion",
    listAppPage: "apkVersion/page",
    listFirmware: "vmc/list",
    appInsert: "apkVersion/insert",
    appUpdate: "apkVersion/update",
    firmware: "vmc/page",
    firmwareInsert: "vmc/insert",
    firmwareupdate: "vmc/update",
    firmwareupload: "upload/vmc",
    updateIp: "userEquipment/updateIp",
    appVersion: "userEquipment/apkUp",
    firmwareVersion: "userEquipment/vmcUp",
    appVersionMore: "userEquipment/apkUpMore",
    firmwareVersionMore: "userEquipment/vmcUpMore",
    firmwareStatus: "userEquipment/vmcUpStatus",
    appStatus: "userEquipment/apkUpStatus",
    appDownConfig: "app/version/app/down",
    superAdminPwdChange: "app/version/apk/super/save",
    appList: "apkVersion/page",
    appInsert2: "app/version/app/insert",
    appExit: "app/version/app/update",
    appDownConfigSave: "app/version/app/down/save",
    allUser: "app/version/role/user",
    updateFlag: "apkVersion/update",
    saveUser: "app/version/role/save",
    oneKeyUp: "apkVersion/upgrade/failure",
    logPage: "equipmentUpRecord/page"
  },
  Feedback: {
    insert: "feedback/insert",
    page: "feedback/page",
    deletes: "feedback/delete",
    update: "feedback/update",
    export: "feedback/export"
  },
  Grouptransfer: {
    delete: "userMoveGroup/delete"
  },
  // TowelCard: {
  //   page: "towelCard/page",
  //   insert: "towelCard/insert",
  //   update: "towelCard/update",
  //   delete: "towelCard/delete",
  //   flow: "towelCard/flow",
  //   dtemplate: "towelCard/template",
  //   import: "towelCard/import",
  //   getCode: "towelCode/get",
  //   saveCode: "towelCode/save"
  // },
  // Ecigarette: {
  //   smokeCard: "smokeCard/page",
  //   insert: "smokeCard/insert",
  //   update: "smokeCard/update",
  //   delete: "smokeCard/delete",
  //   flow: "smokeCard/flow",
  //   dtemplate: "smokeCard/template",
  //   import: "smokeCard/import"
  // },
  Theme: {
    themepage: "equipmentStyle/page",
    machinepage: "userEquipment/page",
    machineSelect: "userEquipment/select",
    configmachine: "equipmentStyle/config",
    themeinsert: "equipmentStyle/insert",
    themeupdate: "equipmentStyle/update",
    adminThemeUpdate: "equipmentStyle/admin/save",
    themedelete: "equipmentStyle/delete",
    getDefault: "equipmentStyle/system/default",
    getAdmin: "equipmentStyle/admin/default"
  },
  Consoles: {
    getMachine: "dashboard/equipment",
    getSales: "dashboard/sales",
    getAlarm: "dashboard/fault",
    getSalesUser: "dashboard/user/ranking",
    getSalesProduct: "dashboard/goods/ranking",
    getSalesMachine: "dashboard/equipment/ranking",
    getSalesDay: "dashboard/sales/day",
    getProportion: "dashboard/proportion"
  },
  AlarmRecord: {
    page: "equipmentFaultRecord/page"
  },
  // Temperature: {
  //   temperature: "userEquipment/temperature",
  //   modifyTemperature: "userEquipment/updateById",
  //   temperatureitem: "userEquipment/temperature/item",
  //   export: "userEquipment/temperature/item/export"
  // },
  // Bouncer: {
  //   userMachineBouncer: "userMachineBouncer/page",
  //   customUserMachineBouncer: "userMachineAgeRecognition/page",
  //   setLink: "userMachineAgeRecognition/update"
  // },
  MachineProfit: {
    statisticsday: "stat/equipment/day",
    statisticstop: "stat/equipment/ranking",
    statisticstable: "stat/equipment/table",
    export: "stat/equipment/export",
    statisticsday2: "userEquipment/page",
    allshops: "goods/list"
  },
  ProductProfit: {
    statisticsday: "stat/goods/day",
    statisticstop: "stat/goods/ranking",
    statisticstable: "stat/goods/table",
    export: "stat/goods/export"
  },
  DateProfit: {
    getSales: "dashboard/sales",
    day: "stat/date/day",
    date: "stat/date/table",
    export: "stat/date/export"
  },
  // MyApps: {
  //   fsList: "userEquipment/splitScreen/page",
  //   chooseMachine: "userEquipment/splitScreen/check",
  //   delMachine: "userEquipment/splitScreen/delete",
  //   fsConfig: "userEquipment/splitScreen/config",
  //   activityList: "promotion/page",
  //   delActivity: "promotion/delete",
  //   upload: "upload/promotion",
  //   getMachine: "promotion/search/userEquipment",
  //   getLineShop: "aisleGoods/page",
  //   getCoupon: "discount/page",
  //   insertActivity: "promotion/insert",
  //   exitActivity: "promotion/update",
  //   endActivity: "promotion/done",
  //   couponList: "coupon/item/page",
  //   recordList: "promotion/winner/page"
  // },
  TemporaryStorageCertificate: {
    list: "age/page",
    del: "age/delete"
  },
  Association: {
    userList: "user/getUserByPage",
    association: "userRelevance/insert",
    associatedList: "userRelevance/getByPage",
    delAssociated: "userRelevance/delete"
  },
  DealerAuthority: {
    load: "userMenu/list3",
    authed: "userMenu/listMenuAndModule",
    saveHideAuth: "userMenu/insert"
  },
  common: {
    upload: "upload/img/common"
  },
  ProductLibrary: {
    page: "goods/material/page",
    delete: "goods/material/delete",
    insert: "goods/material/insert",
    update: "goods/material/update",
    obtain: "goods/material/obtain",
    promote: "goods/material/promote",
    import: "goods/material/import",
    importStatus: "goods/material/import/status",
    setReviewed: "goods/material/reviewed",
    setFlag: "goods/material/flag"
  },
  PrivacyAgreement: {
    Inquiry: "agreementLog/getStatus",
    agree: "agreementLog/agreed",
    page: "agreementLog/page",
    delete: "agreementLog/delete"
  },
  Stripe: {
    add: "user/addStripe",
    create: "pay/STRIPE/WEB",
    machineGetUrl: "/user/getStripePortalSession",
    checkPayment: "userStripe/checkPayment"
  }
};
